import { RootState } from "@/redux/store";

export const tripReportSelector = (state: RootState) => state.tripReporting.tripReport;
